module.exports = __webpack_public_path__ + "img/lolita.a354f437.jpg";